import React, { Suspense, useEffect } from "react";
import {
  Route,
  Routes,
  BrowserRouter as Router,
  useNavigate,
  useLocation,
} from "react-router-dom";
import "./scss/style.scss";
import "primereact/resources/themes/lara-light-indigo/theme.css"; //theme
import "primereact/resources/primereact.min.css"; //core css
import "primeicons/primeicons.css"; //icons
import ProtectedRoutes from "./auth/ProtectedRoutes";
import Auth from "./auth/Auth";
import { removeAuthToken } from "./redux/actions/authTokenAction";
import { removeLoginUser } from "./redux/actions/userAction";
import { dashboardViewAction } from "./redux/actions/dashboardViewAction";
import { useDispatch, useSelector } from "react-redux";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// Containers
const DefaultLayout = React.lazy(() => import("./layout/DefaultLayout"));
// Pages
const ForgotPassword = React.lazy(() =>
  import("./views/pages/forgotpassword/ForgotPasswordForm")
);
const ResetPassword = React.lazy(() =>
  import("./views/pages/passwordforgot/PasswordForget")
);
const Page404 = React.lazy(() => import("./views/pages/page404/Page404"));
const Page500 = React.lazy(() => import("./views/pages/page500/Page500"));
const Login = React.lazy(() => import("./views/pages/login/LoginPage"));

function App() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isTokenValid = useSelector((state) => state.projectDetails);
  const curr_location = useLocation();

  const tokeninfo1 = localStorage.getItem("tokeninfo");
  const tokeninfo = tokeninfo1 ? JSON.parse(tokeninfo1) : null;
  const loginInfo = localStorage.getItem("loginInfo");
  const loginInfo1 = loginInfo ? JSON.parse(loginInfo) : null;

  useEffect(() => {
    if (tokeninfo && (loginInfo1?.user?.permissions.includes("DEVELOPER") || loginInfo1?.user?.permissions.includes("ACCOUNT_ADMIN"))) {
      Auth.signin(() => {
        navigate(`${curr_location.pathname}`);
      });
    } else {
      Auth.signout(() => {
        removeLocalStorage();
        dispatch(removeAuthToken(null));
        dispatch(removeLoginUser({}));
        dispatch(dashboardViewAction(false));
        // Only redirect to login if not on password reset routes
        if (!curr_location.pathname.includes("/passwordforgot") && !curr_location.pathname.includes("/forgotpassword")) {
          navigate("/login");
        }
      });
    }

    function removeLocalStorage() {
      localStorage.removeItem('tokeninfo');
      localStorage.removeItem('loginInfo');
      localStorage.removeItem('userAddress');
      localStorage.removeItem('teanatType');
      localStorage.removeItem('tenantMemberData');
    }
  }, []);

  useEffect(() => {
    if (isTokenValid && isTokenValid === "tokenInvalid") {
      Auth.signout(() => {
        dispatch(removeAuthToken(null));
        dispatch(removeLoginUser({}));
        dispatch(dashboardViewAction(false));
        // Only redirect to login if not on password reset routes
        if (!curr_location.pathname.includes("/passwordforgot") && !curr_location.pathname.includes("/forgotpassword")) {
          navigate("/login");
        }
      });
    }
  }, [isTokenValid]);

  // Route guard for password reset routes
  useEffect(() => {
    if (Auth.getAuth() && (curr_location.pathname.includes("/passwordforgot") || curr_location.pathname.includes("/forgotpassword"))) {
      console.log("curr_location.pathname", curr_location)
      Auth.signout(() => {
        removeLocalStorage();
        dispatch(removeAuthToken(null));
        dispatch(removeLoginUser({}));
        dispatch(dashboardViewAction(false));
        navigate(`${curr_location.pathname}${curr_location.search}`);
      });
    }

    function removeLocalStorage() {
      localStorage.removeItem('tokeninfo');
      localStorage.removeItem('loginInfo');
      localStorage.removeItem('userAddress');
      localStorage.removeItem('teanatType');
      localStorage.removeItem('tenantMemberData');
    }
  }, [curr_location.pathname]);

  return (
    <Suspense fallback={loading}>
      <Routes>
        {Auth.getAuth() ? (
          <>
            <Route element={<ProtectedRoutes />}>
              <Route path="*" element={<DefaultLayout />} />
            </Route>
          </>
        ) : (
          <>
            <Route path="*" element={<Login />} />
            <Route path="/404" element={<Page404 />} />
            <Route path="/500" element={<Page500 />} />
            <Route path="/forgotpassword" element={<ForgotPassword />} /> {/* sent mail for forget password*/}
            <Route path="/passwordforgot" element={<ResetPassword />} /> {/* password forget create new password */}
          </>
        )}
      </Routes>
    </Suspense>
  );
}

export default App;